appConfig.$inject = ['$locationProvider', '$compileProvider'];

export default function appConfig($locationProvider, $compileProvider) {
    $locationProvider.hashPrefix('');
    // deprecated angular.lowercase workaround
    angular.lowercase = angular.$$lowercase;
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|microsoft-edge):/);
}
